export const AddressBookMenuItems = [];
